
import { defineComponent, inject } from 'vue';
import {
    IQuestaoOpcaoEditavel,
    QuestaoOpcaoEditavel,
} from '@/dominio/editor/questoes/questao-opcao/QuestaoOpcaoEditavel';
import {
    IQuestaoSelecaoEditavel,
    QuestaoSelecaoEditavel,
} from '@/dominio/editor/questoes/questao-selecao/QuestaoSelecaoEditavel';
import { Ramificacao } from '@/dominio/editor/questoes/questao-opcao/opcao/Ramificacao';

export default defineComponent({
    name: 'RamificacaoSelecao',
    setup() {
        const proximasQuestoes =
            inject<Array<IQuestaoOpcaoEditavel | IQuestaoSelecaoEditavel>>(
                'proximasQuestoes',
            );
        if (!proximasQuestoes) {
            throw new Error('Não injetada a dependência proximasQuestoes');
        }
        return {
            proximasQuestoes,
        };
    },
    props: {
        ramificacao: {
            type: Ramificacao,
            required: true,
        },
    },
    data() {
        return {
            esteSelecionado: this.ramificacao.getIrPara().toString(),
            erro: '',
        };
    },
    watch: {
        esteSelecionado(novaSelecao: string) {
            this.erro = '';
            if (!novaSelecao) {
                this.erro = 'Valor selecionado vazio';
            } else {
                const ehAvancarOuFim =
                    novaSelecao === 'avançar' ||
                    novaSelecao === 'fim do formulário';
                if (ehAvancarOuFim) {
                    this.ramificacao.setIrPara(novaSelecao);
                    return;
                }
                const proximasQuestoes = this.proximasQuestoes as Array<
                    QuestaoOpcaoEditavel | QuestaoSelecaoEditavel
                >;
                const opcaoSelecionada = proximasQuestoes.find(
                    questao =>
                        questao.getId().toString() === novaSelecao.toString(),
                );
                if (!opcaoSelecionada) {
                    this.erro = 'Erro ao selecionar o tipo de variável';
                    return this.$emit('selecionou', null);
                } else {
                    this.ramificacao.setIrPara(opcaoSelecionada.getId());
                }
            }
        },
    },
});
